/* aw-hero.js — de hero komt binnen zoals het andere thema het doet.
 *
 * Letterlijk uit theme.js van de bron (ImageWithTextOverlay):
 *
 *   timeline([
 *     [target,  {opacity: 1}],
 *     [media,   {opacity:[0,1], scale:[1.1,1], easing:[.215,.61,.355,1], duration:.8}],
 *     [content, {opacity:[0,1], duration:.8}]
 *   ])
 *
 * Een tijdlijn zet elk deel ACHTER het vorige, dus: de foto zoomt in 0,8s van
 * 110% naar 100% en vervaagt tegelijk in beeld, en pas dáárna — vanaf 0,8s —
 * komt de tekst in 0,8s op. Samen 1,6s. Het wacht bovendien tot de foto
 * geladen is (`imageLoaded`), anders animeer je een leeg vlak.
 *
 * De begintoestand staat in CSS en niet hier: een script met `defer` draait pas
 * na het parsen, en dan heb je de hero al een frame vol in beeld gehad.
 */
(() => {
  const CURVE = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
  /* 20 aug: de eigenaar vond hem te sloom. Bij de bron duurt het 1,6s omdat de
     tekst pas BEGINT als de foto klaar is (0,8 + 0,8). Dat wachten is waar het
     traag van voelt, niet de duur van de bewegingen zelf.
     Nu: allebei 0,6s en de tekst start al op 0,3s — dus samen 0,9s en de twee
     bewegingen lopen over elkaar heen. De tijdcurve en de zoom van 110% naar
     100% blijven precies die van de bron. */
  const DUUR = 600;
  const TEKST_START = 300;

  const magBewegen = () => !matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fotoGeladen(img) {
    if (!img) return Promise.resolve();
    if (img.complete && img.naturalWidth) return Promise.resolve();
    return new Promise((klaar) => {
      img.addEventListener('load', klaar, { once: true });
      img.addEventListener('error', klaar, { once: true });
      setTimeout(klaar, 3000);   // nooit eeuwig wachten op een trage foto
    });
  }

  async function speel(hero) {
    if (hero.dataset.awHero) return;
    hero.dataset.awHero = '1';

    const foto = hero.querySelector('.hero__media');
    const inhoud = hero.querySelector('.hero__content-wrapper');

    if (!magBewegen()) { hero.classList.add('aw-hero--klaar'); return; }

    await fotoGeladen(foto);
    hero.classList.add('aw-hero--speelt');

    if (foto) {
      foto.animate(
      /* 20 aug: GEEN opacity-stappen meer op de FOTO, alleen de zoom.
         Waarom: dit script zette de hero op opacity 0 aan het begin van de
         animatie, en een element op opacity 0 telt niet mee als LCP-kandidaat.
         De CSS was al aangepast, maar zolang dit hier stond verstopte het
         script de foto alsnog.
         De zoom van 110% naar 100% blijft, en de TEKST vervaagt nog gewoon. */
        [{ transform: 'scale(1.1)' }, { transform: 'scale(1)' }],
        { duration: DUUR, easing: CURVE, fill: 'forwards' }
      );
    }
    if (inhoud) {
      inhoud.animate(
        [{ opacity: 0 }, { opacity: 1 }],
        { duration: DUUR, delay: TEKST_START, easing: 'linear', fill: 'forwards' }
      );
    }
    setTimeout(() => hero.classList.add('aw-hero--klaar'), TEKST_START + DUUR + 60);
  }

  function start() {
    document.querySelectorAll('.hero').forEach((hero) => {
      if (!('IntersectionObserver' in window)) { speel(hero); return; }
      const kijker = new IntersectionObserver((rijen) => {
        for (const r of rijen) {
          if (r.isIntersecting) { kijker.disconnect(); speel(hero); }
        }
      }, { threshold: 0.05 });
      kijker.observe(hero);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
